import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  contactContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  blueLayout: {
    backgroundImage: 'linear-gradient(#3560FF, #3C419A)',
  },
  contactButton: {
    textAlign: 'right',
    marginBottom: 5,
  },
  contactButtonLeft: {
    textAlign: 'left',
    marginTop: 20,
    marginBottom: 10,
  },
  contactData: {
    flexGrow: 1,
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    textAlign: 'center',
    margin: '5px',
    minHeight: '400px',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
  icon: {
    width: '35px !important',
    height: '35px !important',
  },
  left: {
    float: 'left',
  },
  right: {
    float: 'right',
  },
  clearBoth: {
    clear: 'both',
  },
  rightWithMargin: {
    float: 'right',
    marginTop: '25px',
  },
  linkContent: {
    color: 'white',
    borderRadius: '8px',
    padding: '10px',
    border: 'none',
    width: '100%',
  },
  linkPadding: {
    padding: 10,
  },
  breadcrumbHeader: {
    position: 'relative',
    left: '-30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    width: 'auto',
    height: '70px',
  },
  blueP: {
    margin: '0 auto',
  },
  blueBigButton: {
    cursor: 'pointer',
  },
  pMovie: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
  aWithoutHref: {
    color: '-webkit-link',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '16px',
  },
  descriptionContainer: {
    textAlign: 'left',
    paddingRight: 40,
  },
  qlEditor: {
    padding: '0!important',
  },
  h3: {
    fontSize: '1.17em',
    fontWeight: 'bold',
    marginTop: '1em',
    marginBottom: '1em'
  }
}));
